import Model from "~/models/_Model";
import Course from "./Course";

export default class CourseRequest extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courseplanner";
  }

  // Set the resource route of the model
  resource() {
    return "course-requests";
  }

  relations() {
    return {
      course_info: Course,
      alt_course_info: Course,
    };
  }

  // Computed Attributes
  get display_request() {
    if (!this.course_info) {
      return this.course;
    }
    return `${this.course}: ${this.course_info.DESCRIPTION_CLEAN}`;
  }

  get display_request_type() {
    switch (this.request_type) {
      case "regular":
        return "Regular Request";
      case "alternate":
        return "Alternate Request";
      default:
        return this.request_type;
    }
  }

  get display_course_marking_periods() {
    return this.course_marking_period || "Any"; //.replace(',',', ')
  }

  get sort_key() {
    return this.request_type == "regular"
      ? `1-${this.course.trim()}`
      : this.request_type == "alternate"
      ? `2-${this.alt_course_priority}-${this.course.trim()}`
      : `3-${this.course.trim()}`;
  }
}
